import Flickity from "flickity";
import { trackEvent } from "../utils/matomo";

export default function Listcomplex() {
  Alpine.data("listcomplex", () => ({
    activeIndex: null,
    canPrev: false,
    canNext: false,
    _sliders: {},

    init() {
      requestAnimationFrame(() => {
        this.activeIndex = null;
      });
      this.$watch("activeIndex", (val) => {
        document.body.style.overflow = val !== null ? "hidden" : "";
      });
    },

    open(index, headline) {
      trackEvent("List Complex", "Open Row", headline);
      this.activeIndex = index;
      this.$nextTick(() => this._initSlider(index));
    },

    close() {
      this.activeIndex = null;
    },

    isOpen(index) {
      return this.activeIndex === index;
    },

    _initSlider(index) {
      if (this._sliders[index]) {
        this._sliders[index].resize();
        this._updateNav();
        return;
      }

      const panel = this.$root.querySelector(`[data-panel="${index}"]`);
      const track = panel ? panel.querySelector("[data-track]") : null;
      if (!track) return;

      const flkty = new Flickity(track, {
        cellAlign: "left",
        contain: true,
        wrapAround: false,
        pageDots: false,
        prevNextButtons: false,
        draggable: true,
      });

      flkty.on("change", () => this._updateNav());

      this._sliders[index] = flkty;
      this._updateNav();
    },

    _updateNav() {
      const flkty = this._sliders[this.activeIndex];

      this.canPrev = !!flkty && flkty.selectedIndex > 0;
      this.canNext = !!flkty && flkty.selectedIndex < flkty.slides.length - 1;
    },

    prevSlide() {
      const flkty = this._sliders[this.activeIndex];
      if (flkty) flkty.previous();
    },

    nextSlide() {
      const flkty = this._sliders[this.activeIndex];
      if (flkty) flkty.next();
    },
  }));
}
